import React from "react";
import HeroSection from "../components/HeroSection";
import PhilosophySection from "../components/PhilosophySection";
import FeaturedChantings from "../components/FeaturedChantings";
import WatchAndListen from "../components/WatchAndListen";
import AboutSection from "../components/AboutSection";

const HomePage = () => {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <PhilosophySection />
      <FeaturedChantings />
      <WatchAndListen />
      <AboutSection />
    </main>
  );
};

export default HomePage;
